import { render, staticRenderFns } from "./ContinuousFilingMessagesDetails.vue?vue&type=template&id=da048988&scoped=true&"
import script from "./ContinuousFilingMessagesDetails.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingMessagesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da048988",
  null
  
)

export default component.exports